import { CriticalError } from '../error/error';

export class ConfigParserError extends CriticalError
{
  protected _name: string = 'ConfigParserError';
}

export abstract class ConfigParser
{
  protected genericConfigObject: any;

  /**
   * @param genericConfigObject ein allgemeines Objekt, das die zu parsende
   * Konfiguration enthält
   */
  public constructor(genericConfigObject: any)
  {
    this.genericConfigObject = genericConfigObject;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/config/config-parser.ts